<script>
import { CommonFile } from '@/types/commonFile.js'
import { dragscroll } from 'vue-dragscroll'

/**
 * Word and PowerPoint documents must be less than 10 megabytes; Excel must be less than five megabytes
 */
export default {
  directives: { dragscroll },
  data() {
    return {
      loadeed: 0,
      pdf: {
        countPage: 0,
        page: 1,
        showPages: 1,
        src: ''
      },
      img_available: [ 'png', 'jpeg', 'jpg', 'bmp', 'gif' ],
      iframe_available: [ 'rtf', 'csv', 'tiff' ],
      iframe_office: [
        'xls', 'xlsx', 'xlsb', 'xlsm',  //Excel
        'doc', 'docx', 'docm', 'dotm', 'dotx',  //Word
        'ppt', 'pptx', 'ppsx', 'pps', 'pptm', 'potm', 'ppam', 'potx', 'ppsm'  //PowerPoint
      ],
    }
  },
  methods: {
    saveFile() {
      if (this.newEndpoints) {
        this.file.downloadFile()
      } else {
        this.file.saveFile()
      }
    },
    printDocument() {
      if (this.pdf_type) {
        return
      }
      let needPrint = false
      let newChild
      if (this.html_type) {
        const iframe = this.$refs.document_view ?  this.$refs.document_view.$refs.html_viewer : this.$refs.html_viewer

        if (!iframe) {
          this.$notice.warning({
            title: 'Помилка друку',
            duration: 10,
          })
          return
        }
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document

        const printWindow = window.open('', '', 'width=800,height=600')
        printWindow.document.write(iframeDocument.documentElement.innerHTML)
        printWindow.document.close()
        printWindow.print()
      } else if (this.img_type) {
        document.getElementById('app').classList.add('hidden-print')

        const iframe = this.$refs.document_view ?  this.$refs.document_view.$refs.img_viewer : this.$refs.img_viewer
        if (!iframe) {
          this.$notice.warning({
            title: 'Помилка друку',
            duration: 10,
          })

          return
        }
        newChild = iframe.cloneNode(true)
        newChild.id = 'print-item'
        document.body.appendChild(newChild)
        needPrint = true
      }

      if (needPrint) {
        window.print()
        document.getElementById('app').classList.remove('hidden-print')
        document.body.removeChild(newChild)
      }
    },
    reload() {
      setTimeout(() => {
        if ( this.loadeed !== true && this.loadeed < 15
          && this.$refs.iframe && this.dialog) {
          try {
            this.$refs.iframe.src += ''
            this.$refs.iframe.contentWindow.location.reload()
            this.loadeed += 1
            this.reload()
          } catch (er) {
            this.$log('st wrong!', er)
          }
        }
      }, 8000)
    },
    load() {
      this.loadeed = true
    },
    close() {
      this.open = false
    },
  },
  // mounted() {
  //   this.openFile()
  // },
  props: {
    file: [CommonFile, Object],
    newEndpoints: Boolean
  },
  computed: {
    main_link() {
      if (this.newEndpoints) {
        return `${window.config?.GrapgQlUrl}/document/${this.file?.key}`
      }
      return `${window.config?.SmarttenderUrl}Attachment/DownloadAttachmentByKey/${this.file?.key}`
    },
    iframe_link() {
      let url
      if (this.other_type) {
        url = 'https://docs.google.com/viewer?embedded=true&url=' + this.main_link
      }
      if (this.office_type) {
        url = 'https://view.officeapps.live.com/op/view.aspx?src=' + this.main_link
      }
      this.reload()
      return url
    },
    img_link() {
      if (this.img_type) {
        return this.main_link
      }
      return ''
    },
    other_type() {
      return this.iframe_available.some(type => type == this.file?.getFileExtension)
    },
    office_type() {
      return this.iframe_office.some(type => type == this.file?.getFileExtension)
    },
    img_type() {
      return this.img_available.some(type => type == this.file?.getFileExtension)
    },
    html_type() {
      return 'html' == this.file?.getFileExtension
    },
    pdf_type() {
      return 'pdf' == this.file?.getFileExtension
    },
  },
  watch: {
    main_link: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || oldValue !== newValue) {
          this.$emit('changeLink')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.icon-loaded {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  background: var(--black-color);
  opacity: 0.5;
}
.document-view {
  height: 100%;
  width: 100%;
}
.viewer-wrapper {
  overflow: auto;
  max-height: 100%;
  height: 100%;
  max-width: 100%;
  width: 100%;
  align-items: center;
  justify-items: center;
  display: flex;
  flex-wrap: wrap;
  &.zoom-active {
    cursor: grab;
  }
  img {
    margin: auto;
    max-width: 100%;
    max-height: 99%;
  }
  iframe , .html_viewer{
    margin: auto;
    width: 100%;
    height: 99%;
  }
}
</style>
